import { declareString } from "@1js/localization";

export const FilterLabel = declareString("promptLibrary.groupPromptsFilter", {
  text: "Select or enter a team name",
  comment:
    "Placeholder label used on the Team Copilot prompts filter component",
});

export const OwnerTeamsLabel = declareString("promptLibrary.ownerTeamsLabel", {
  text: "Teams you own",
  comment:
    "Label of an OptionGroup to display all teams where customer is a co-owner.",
});

export const MemberTeamsLabel = declareString(
  "promptLibrary.memberTeamsLabel",
  {
    text: "Teams you're a member of",
    comment:
      "Label of an OptionGroup to display all teams where customer is a member of.",
  }
);
